module.exports = __webpack_public_path__ + "img/chocolate_box_gift.5ab293fe.svg";